import { postRequest, formDataPutRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const getAgentListing = (id, body) => {
  return postRequest(`Property/GetAllPropertyList/${id}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const giveAgentRating = (data) => {
  return postRequest(`agent/add-rating`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateAgentProfile = (data) => {
  return formDataPutRequest(`Agent`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const reSubmitApprovalRequest = (id) =>
  postRequest(`Agent/resubmit-approval-request/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

export const agentService = {
  giveAgentRating,
  getAgentListing,
  updateAgentProfile,
  reSubmitApprovalRequest,
};
